import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewReviewLoading {
  Set = 'NEW_REVIEW/LOADING/SET',
}

export type TNewReviewLoading = ITypedReduxAction<ENewReviewLoading.Set, boolean>;

export type TNewReviewLoadingActions = TNewReviewLoading;

export const setLoading: (loading: boolean) => TNewReviewLoading = actionGenerator<ENewReviewLoading.Set, boolean>(
  ENewReviewLoading.Set,
);
